export default "__VITE_ASSET__D4ifhav1__"